// extracted by mini-css-extract-plugin
module.exports = {"authorsLine":"styles-module__authorsLine___2rCtY"};